import { locationsProfilesConstants } from '@constants/locations-profiles';

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export function locationsProfiles(state = initialState, action) {
    switch (action.type) {
        case locationsProfilesConstants.LOCATIONS_PROFILES_FETCH:
            return { ...state, loading: true };
        case locationsProfilesConstants.LOCATIONS_PROFILES_SUCCESS:
            return { ...state, loading: false, data: action.data };
        case locationsProfilesConstants.LOCATIONS_PROFILES_ERROR:
            return { ...state, loading: false };
        case locationsProfilesConstants.LOCATIONS_PROFILES_RESET:
            return { ...state, data: [] };
        default:
            return state;
    }
}
